import {MenuItems} from "@/types";
import {$t} from "@/lib/helpers/i18nHelper";

export const mainMenuItems: MenuItems = [
  {
    title: $t("Dashboard"),
    name: "dashboard",
    icon: "dashboard",
    exact: true,
    route: {
      name: "dashboard",
    },
  },
  {
    title: $t("Users"),
    name: "users",
    icon: "account_box",
    route: { name: "users" },
  },
  {
    title: $t("Transactions"),
    name: "transactions",
    icon: "monetization_on",
    route: { name: "transactions" },
  },
  {
    title: $t("My profile"),
    name: "myProfile",
    icon: "account_box",
  },
  {
    title: $t("Settings"),
    name: "settings",
    icon: "settings",
    route: { name: "settings" },
  },
  {
    title: $t("Logout"),
    name: "logout",
    icon: "exit_to_app",
    route: { name: "logout" },
  },
];
